import api from "../../../api/api";
import s from "./styles.module.css"
import {toast} from "react-toastify";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import React from "react";
import {Tooltip} from "@mui/material";

function PortalSendButton({disabled, ageGroupId, disciplineId, disciplineStageId, portalData, onSent}) {
    const sendPortal = portalData?.sendPortal ?? null;
    const lastChangePortal = portalData?.lastChangePortal ?? null;
    const hasNewChange = portalData?.hasNewChange ?? false;
    const key = `${ageGroupId}_${disciplineId}_${disciplineStageId}`;

    const handleSend = async () => {
        const res = await api().get(
            `/portal/send/${ageGroupId}/${disciplineId}/${disciplineStageId}`
        );
        if (res?.data?.status === "ok") {
            onSent(key, res.data.sendPortal);
            toast.success("Данные отправлены на портал!");
        } else {
            toast.error("Ошибка отправления данных!")
        }
    };

    return (
        <div style={{position: "relative", display: "inline-block"}}>
            <Tooltip title="Выгрузка результатов на портал">
                <button disabled={disabled} onClick={handleSend} className={s.portalButton}>
                    <CloudUploadIcon/>
                </button>
            </Tooltip>
            {hasNewChange && (
                <span style={{
                    position: "absolute", top: -4, right: -4,
                    width: 10, height: 10, borderRadius: "50%", backgroundColor: "red",
                }}/>
            )}
        </div>
    );
}

export default PortalSendButton;